import { DSModal } from "@components/design-system/organisms";
import React from "react";
import { FormProvider, useWatch } from "react-hook-form";

import ExportForm from "./ExportForm";

export default function ExportModal({
  shouldShowModal,
  hideModal,
  handleSubmit,
  onSend,
  control,
  methods,
  isClientSummaryMode = false,
  isClientSummaryModalOpen = false,
  getValues,
  note,
}) {
  const clientSummary = useWatch({ control, name: "clientSummary" });

  return (
    <DSModal
      isOpen={shouldShowModal}
      onClose={hideModal}
      title={`Export Your ${
        isClientSummaryMode ? "Client Summary" : "Note"
      }`}
      actions={[
        {
          label: "Cancel",
          variant: "cancel",
          onClick: hideModal,
        },
        {
          label: "Send",
          variant: "primary",
          onClick: handleSubmit(onSend),
          dataTestId: "confirm-button",
        },
      ]}
      dataTestId="Send-modal"
    >
      <FormProvider {...methods}>
        <ExportForm
          isClientSummaryModalOpen={isClientSummaryModalOpen}
          isClientSummaryMode={isClientSummaryMode}
          control={control}
          methods={methods}
          clientSummary={clientSummary}
          getValues={getValues}
          note={note}
        />
      </FormProvider>
    </DSModal>
  );
}
